import React from 'react';
export default function Indentation(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "fabric-editor-block-mark fabric-editor-indentation-mark",
    "data-level": props.level
  }, props.children);
}